import { render, staticRenderFns } from "./Benestare.vue?vue&type=template&id=f91316c4&"
import script from "./Benestare.vue?vue&type=script&lang=js&"
export * from "./Benestare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports